import React from 'react';
import NavBar from './navBar';

const FooterDiv = () => {
  return (
    <footer>
        <NavBar/>
    </footer>
  )
}

export default FooterDiv;